import i18n from '../../i18n/config';

const METADATA_EXTRACTION_VALUES = [
  'fromAI',
  'fromFileName',
  'fromUser',
] as const;
export type METADATA_EXTRACTION_TYPE =
  (typeof METADATA_EXTRACTION_VALUES)[number];
export const METADATA_EXTRACTION_FROM_AI_VALUE = METADATA_EXTRACTION_VALUES[0];
export const METADATA_EXTRACTION_FROM_FILE_NAME_VALUE =
  METADATA_EXTRACTION_VALUES[1];
export const METADATA_EXTRACTION_FROM_USER_VALUE =
  METADATA_EXTRACTION_VALUES[2];

export type METADATA_OPTIONS_TYPE = {
  label: string;
  labelIconName?: string;
  value: METADATA_EXTRACTION_TYPE;
  disabled?: boolean;
};

const METADATA_EXTRACTION_AI_OPTION = {
  label: i18n.t('app.upload.metadataExtractinConfig.configOption.fromAI'),
  value: METADATA_EXTRACTION_FROM_AI_VALUE,
  labelIconName: 'aiMetadataExtraction',
};
const METADATA_EXTRACTION_FILE_OPTION = {
  label: i18n.t('app.upload.metadataExtractinConfig.configOption.fromFileName'),
  value: METADATA_EXTRACTION_FROM_FILE_NAME_VALUE,
};
const METADATA_EXTRACTION_USER_OPTION = {
  label: i18n.t('app.upload.metadataExtractinConfig.configOption.fromUser'),
  value: METADATA_EXTRACTION_FROM_USER_VALUE,
};

export const getMetadataExtractionOptions = (
  hasPerFileInputFields: boolean,
  fileDocMetadaExtractionEnabled: boolean
) => {
  if (hasPerFileInputFields && fileDocMetadaExtractionEnabled) {
    return [
      METADATA_EXTRACTION_AI_OPTION,
      METADATA_EXTRACTION_FILE_OPTION,
      METADATA_EXTRACTION_USER_OPTION,
    ];
  }

  if (hasPerFileInputFields) {
    return [METADATA_EXTRACTION_AI_OPTION, METADATA_EXTRACTION_USER_OPTION];
  }

  return [METADATA_EXTRACTION_FILE_OPTION];
};
